import { atom } from "recoil";
import { Configuration, LoginResponse, Role } from "../api/auth";
import { Employee } from "../api/clinic-management";
import { BASE_PATH } from "../environment";

export const drawerAtom = atom<boolean>({
  key: "drawer",
  default: true,
});

export const idAtom = atom<number[]>({
  key: "id",
  default: [],
});

export const configState = atom<Configuration>({
  key: "configState",
  default: {
    basePath: BASE_PATH,
    apiKey: localStorage.getItem("AccessToken")! || "",
  },
});

export const loginInfo = atom<LoginResponse>({
  key: "loginInfo",
  default: JSON.parse(localStorage.getItem("LoginInfo")!),
});

export const branchRoles = atom<Role[]>({
  key: "branchRoles",
  default: JSON.parse(localStorage.getItem("BranchRoles")!),
});

export const loggedEmployee = atom<Employee>({
  key: "LoggedEmployee",
  default: JSON.parse(localStorage.getItem("LoggedEmployee")!),
});
